import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { clearStoredAuth, getStoredUser, hasActiveSession } from "../utils/authStorage";

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [sessionActive, setSessionActive] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const syncAuth = () => {
      const active = hasActiveSession();
      setSessionActive(active);
      setCurrentUser(active ? getStoredUser() : null);
    };

    syncAuth();
    window.addEventListener("storage", syncAuth);
    return () => window.removeEventListener("storage", syncAuth);
  }, [location.pathname]);

  const role = String(currentUser?.role || "guest").toLowerCase();
  const isAdmin = sessionActive && role === "admin";
  const displayName =
    currentUser?.username ||
    (currentUser?.email ? currentUser.email.split("@")[0] : "Guest");
  const displayRole = role === "admin" ? "Admin" : role === "contributor" ? "Contributor" : "Guest";

  const handleExit = () => {
    try {
      window.close();
    } catch {
      // browser limitation
    }
    setTimeout(() => navigate("/"), 120);
  };

  const handleLogout = () => {
    clearStoredAuth();
    setSessionActive(false);
    setCurrentUser(null);
    navigate("/");
  };

  return (
    <header className="main-navbar">
      <div className="nav-container nav-container-merged">
        <div className="nav-center-stack">
          <Link to="/home" className="nav-center-logo">
            <span className="nav-center-logo-icon" aria-hidden="true">🌿</span>
            <span>EcoTrack 2.0</span>
          </Link>
          <span className="nav-center-subtitle">India Biodiversity Intelligence Platform</span>
        </div>

        <div className="nav-controls-row">
          {isAdmin ? (
            <button
              type="button"
              className="utility-btn utility-btn-admin"
              onClick={() => navigate("/admin")}
            >
              Admin Panel
            </button>
          ) : null}

          <div className="utility-user-chip" title={currentUser?.email || "Guest user"}>
            <span className={`utility-user-dot ${sessionActive ? "online" : "offline"}`} />
            <span className="utility-user-name">{displayName}</span>
            <span className={`utility-user-role role-${role}`}>{displayRole}</span>
          </div>

          {sessionActive ? (
            <button
              type="button"
              className="utility-btn utility-btn-logout"
              onClick={handleLogout}
            >
              Logout
            </button>
          ) : null}
        </div>

        <button
          type="button"
          className="nav-exit-x"
          onClick={handleExit}
          title="Exit app"
          aria-label="Exit app"
        >
          ×
        </button>
      </div>
    </header>
  );
}
